/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import { useState } from 'react';
import { Slider } from 'antd';
import './index.css';
import { PRODUCT_NAME } from '@/constants';

// const TITLE = 'See How Much You Can Save with Green Shipping Protection';
const config = {
  trackStyle: {
    background: '#235935',
  },
  railStyle: {
    background: '#fff',
    border: '1px dashed #bdc1cc',
  },
  handleStyle: {
    color: '#235935',
  },
  tooltip: {
    open: false,
  },
};
const toThousands = (val) => val.toString().replace(/(?=\B(\d{3})+$)/g, ',');

const getSaving = (value, volume) => {
  const res = value * (volume / 100) * 0.2 * 4.5;
  return toThousands(res);
};
const Extra = ({ name }) => {
  const [averageValue, setAverageValue] = useState(320);
  const [annualVolume, setAnnualVolume] = useState(1000);

  return (
    <div className="seel_extra_wrapper">
      <div className="extra_title">{`See How Much You Can Save with ${name === 'Shopify' ? PRODUCT_NAME.WORRY_FREE_PURCHASE : PRODUCT_NAME.GREEN_SHIPPING_PROTECTION}`}</div>
      {/* <input type="range" id="range" /> */}
      <div className="slider">

        <div className="slider_title">
          <span>Average Order Value</span>
          <span>
            {`$${toThousands(averageValue)}`}
          </span>
        </div>
        <Slider
          min={10}
          max={1000}
          step={10}
          onChange={(e) => setAverageValue(e)}
          value={averageValue}
          {...config}
        />
        <div className="slider_title">
          <span>Annual Order Volume</span>
          <span>
            {`${toThousands(annualVolume)}`}
          </span>
        </div>
        <Slider
          min={1000}
          max={10000000}
          step={1000}
          onChange={(e) => setAnnualVolume(e)}
          value={annualVolume}
          {...config}
        />
      </div>
      <div className="divider"></div>
      <div className="footer">
        <div className="footer_title">Lost revenue recaptured</div>
        <div className="saving">
          {`$${getSaving(averageValue, annualVolume)} USD`}
          <span className="year"> / year</span>
        </div>
      </div>
    </div>
  );
};

export default Extra;
